class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForms: '[action="/cart/add"]:not(.ctl-product-form [action="/cart/add"])',
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      cartCount: '.cart-count',
      
    }

    this.init();
  }

  init() {
    window.log("Initialising global QF listeners");
    let vm = this;
    document.body.addEventListener('click', function (e) {
      vm.productQuickAdd(e)
      vm.siteCart(e)
      vm.quantityButtons(e)
      vm.removeCartItem(e)
    })
    vm.productForm();
    vm.cartRelated();
    vm.headerSearch();
    vm.mobileMenu();
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      if (quickAdd.dataset.id && quickAdd.dataset.quantity && quickAdd.dataset.quantity > 0) {
        window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quickAdd.dataset.quantity}] });
        e.preventDefault();
      }
    }
  }

  productForm() {
    // PRODUCT FORM LISTENER
    let productForms = document.querySelectorAll(this.selectors.productForms);
    for (let i = 0; i < productForms.length; i++) {
      let productForm = productForms[i];
      productForm.addEventListener("submit", function (e) {
        e.preventDefault();
        let quantity = productForm.querySelector("input.quantity-selector").value;
        let id = productForm.querySelector("#product-id").value;

        let properties = {};
        const prop_els =  productForm.querySelectorAll('[name^="properties"]');
        console.log('🌹 PROP ELS: ', prop_els );

        prop_els.forEach( prop => {
          let prop_name = prop.name.replace('properties[', '').replace(']','').trim();
          let prop_value = prop.value;
          
          properties[prop_name] = prop_value;

        })

        console.log('🌻 all_properties', properties);

        if (quantity && id) {
          window.cart.add({ items: [{ 
            "id": id, 
            "quantity": quantity,
            "properties": properties
        }] });
        }
      });
    }
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (window.QF.settings.sideCart) {
      const openSideCart = e.target.closest(this.selectors.openSideCart);
      if (openSideCart) {
        e.preventDefault();
        window.cart.openSideCart();
      }

      const closeSideCart = e.target.closest(this.selectors.closeSideCart);
      const closeSideCartByOverlay = e.target.getAttribute('id');
      if (closeSideCart || closeSideCartByOverlay == 'cart-drawer-container') {
        e.preventDefault();
        window.cart.closeSideCart();
      }
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus)
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") == "true") return false;
      quantityPlus.setAttribute("data-pending", true);

      let quantity = quantityPlus.parentNode.querySelector(".quantity span");
      let stock = quantity.getAttribute("data-stock");
      let variant_id = quantity.getAttribute("data-variant-id");
      let inv_policy = quantity.getAttribute("data-inventory-policy");
      if (inv_policy == "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        window.cart.add({ items: [{ "id": variant_id, "quantity": quantity }] });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus)
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") == "true") return false;
      quantityMinus.setAttribute("data-pending", true);

      let quantity = quantityMinus.parentNode.querySelector(".quantity span");
      let current = parseInt(quantity.innerHTML);
      let variant_id = quantity.getAttribute("data-variant-id");

      if (current > 0) {
        let updated = current - 1;
        window.cart.update({ updates: { [variant_id]: updated } });
      }
    }
  }

  getWishlist = () => {
    const wishlist = localStorage.getItem("shopify-wishlist") || false;
    if (wishlist) return wishlist.split(",");
    return [];
  };

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons)
    if (removeButtons) {
      let wishlistModal = document.querySelector('.wishlist-modal');
          modalBtn = wishlistModal.querySelector('[button-wishlist]');
      const activeWishlist = this.getWishlist();
      const productHanlde = removeButtons.getAttribute("data-handle");
      
      if(!activeWishlist.includes(productHanlde)) {
        modalBtn.setAttribute('data-product-handle', removeButtons.getAttribute("data-handle"));
        wishlistModal.classList.add('open');
      }
      

      let variant_id = removeButtons.getAttribute("data-variant-id");
      window.cart.remove(variant_id)
    }
  }

  cartRelated() {
    // update side cart/cart after change
    let renderCarts = () => {
      if (window.template == "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", (e) => {
      if (e.detail.cart) {
        let cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach((count) => {
          count.innerHTML = e.detail.cart.item_count;
        })
      }
    })
  }

 // HEADER SEARCH
 headerSearch(e) {
  const search = document.querySelector('.mega-menu .header-left-bar .header-search-bar-wrapper');
  const searchTrigger = document.querySelector('.mega-menu .header-left-bar [data-open-search]');
  const searchInput = document.querySelector('.mega-menu .header-left-bar .header-search-bar-wrapper .search-bar-qf input');

  // Check Search exists
  if (search) {
    // Open / Close Search
    window.addEventListener('click', function (e) {
      let target = e.target;
      
      if (target.hasAttribute('data-open-search')) {
        if (target.classList.contains('active')) {
          // Return if active
          return;
        } else {
          // Open if not active
          searchTrigger.classList.add('active');
          search.classList.add('active');
          searchInput.focus();
        }
      } else if (target.classList.contains('header-search') || target.getAttribute('id') == 'submit_search' || target.closest(".predictive-search-modal")) {

        // Do nothing if search is clicked
        return;
      } else {
        // Close if clicked off
        searchTrigger.classList.remove('active');
        search.classList.remove('active');
      }
    });

    // Close search with Escape Key
    window.addEventListener('keydown', function (e) {
      let key = e.key;

      if (key == 'Escape') {
        if (window.activeElement.classList.contains('header-search')) {
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
        } else {
          return;
        }
      }
    });
  }

}

  // MOBILE MENU
  mobileMenu(e) {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const body = document.querySelector('body');

    if (menuTrigger) {
      menuTrigger.addEventListener('click', function () {
        if (menuTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
          body.removeAttribute('style');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
          body.setAttribute('style', 'overflow: hidden;');
        }
      });
    }

    menu.addEventListener('click', function (e) {
      if (e.target.classList.contains('mobile-menu-outer-wrapper')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        body.removeAttribute('style');
      }
    })

    const openSubmenuBtn = menu.querySelectorAll('.js-openSubmenu');
    const closeSubmenuBtn = menu.querySelectorAll('.js-closeSubmenu');

    openSubmenuBtn.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        btn.closest('button').nextElementSibling.classList.toggle('active');
      })
    })

    closeSubmenuBtn.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        btn.closest('.js-submenu').classList.remove('active');
      })
    })

  }

}

window.GlobalListeners = GlobalListeners;